export default "__VITE_ASSET__dfdc401c__"